import { useTranslation } from 'react-i18next'

import { ArrowUDownLeft, Percent, ShoppingCart } from '@phosphor-icons/react'

import { FormatNumber } from '@reveni-io/reveni-ui'

import { statisticOrientations } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'
import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

const ReturnSalesData = ({ metrics, total, returned, rate }) => {
  const { t } = useTranslation()

  return (
    <StatisticGroup orientation={statisticOrientations.vertical}>
      <Statistic
        size="small"
        isOutlined={false}
        Icon={ShoppingCart}
        label={t(metrics.total.label)}
        value={total || '-'}
        orientation="horizontal"
      />
      <Statistic
        size="small"
        isOutlined={false}
        Icon={ArrowUDownLeft}
        label={t(metrics.returned.label)}
        value={returned || '-'}
        orientation="horizontal"
      />
      <Statistic
        size="small"
        isOutlined={false}
        Icon={Percent}
        label={t(metrics.rate.label)}
        value={<FormatNumber style="percent">{Number(rate || 0)}</FormatNumber>}
        orientation="horizontal"
      />
    </StatisticGroup>
  )
}

export default ReturnSalesData
